import React from 'react';
import Media from '../components/media/Media';

const MediaPage = () => {
  return (
    <Media />
  );
};

export default MediaPage; 